import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import * as Sentry from "@sentry/react"
const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0); // 🆕 added

  const markAllAsRead = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_SERVER_ENDPOINT}/api/mark-notifications-read`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const updated = notifications.map((n) => ({ ...n, is_read: true }));
      setNotifications(updated);
      setUnreadCount(0); // reset unread count
    } catch (error) {
      console.error("Failed to mark notifications as read", error);
      Sentry.captureException(error);
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        setNotifications,
        unreadCount,          
        setUnreadCount,       
        markAllAsRead
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};